<template>
  <div class="container bg-hui">
    <div class="content-box p48 predict">
      <div class="number">约<b>{{data.totalRealFee | calcPriceFun}}</b>元</div>
      <ul class="priceList" v-if="data.chargeType != 4">
        <li v-if="data.startPrice"><span>{{data.startPrice | calcPriceFun}}元</span>起步价<i>({{data.startkilometers
          |
          meters}}公里)</i></li>
        <li v-if="data.orderMileageFee"><span>{{data.orderMileageFee | calcPriceFun}}元</span>里程费<i>({{data.orderMileages
          |
          meters}}公里)</i></li>
        <li v-if="data.longTimeFee"><span>{{data.longTimeFee | calcPriceFun}}元</span>时长费<i>({{data.longTimes
          |
          formatDuringFun}})</i>
        </li>
        <li v-if="data.longDistanceFee"><span>{{data.longDistanceFee | calcPriceFun}}元</span>远途费<i>({{data.longDistances
          |
          meters}}公里)</i></li>
        <li v-if="data.waitTimeFee"><span>{{data.waitTimeFee | calcPriceFun}}元</span>等候费<i>({{data.waitTimes|
          formatDuringFun}}分钟)</i>
        </li>
        <!-- <li v-if="data.waitTimeFee"><span>{{data.waitTimeFee | calcPriceFun}}元</span>保险费<i>({{data.waitTimes|
          formatDuringFun}}分钟)</i>
        </li>
        <li v-if="data.waitTimeFee"><span>{{data.waitTimeFee | calcPriceFun}}元</span>动态加价<i>({{data.waitTimes|
          formatDuringFun}}分钟)</i>
        </li> -->
        <li v-if="data.insuranceFee"><span>{{data.insuranceFee | calcPriceFun}}元</span>基础信息服务费</li>
        <li v-if="data.dynamicPrice"><span>{{data.dynamicPrice | calcPriceFun}}元</span>动态加价</li>
        <li v-if="data.reductionFee"><span>-{{data.reductionFee | calcPriceFun}}元</span>司机减免</li>
        <li v-if="data.otherFee"><span>{{data.otherFee | calcPriceFun}}元</span>其他费用</li>
        <li v-if="data.coupon"><span>-{{data.coupon | calcPriceFun}}元</span>优惠券</li>
      </ul>
      <ul class="priceList" v-else>
        <li v-if="data.totalRealFee"><span>{{data.totalRealFee | calcPriceFun}}元</span>一口价</li>
        <li v-if="data.insuranceFee"><span>{{data.insuranceFee | calcPriceFun}}元</span>基础信息服务费</li>
        <li v-if="data.coupon"><span>-{{data.coupon | calcPriceFun}}元</span>优惠券</li>
      </ul>
      <hr>
      <div class="font-gray" v-if="data.chargeType != 4">预估费用仅供参考，最终订单费用可能受行驶路线、交通情况、天气等因素影响与预估费用不同</div>
      <div class="font-gray" v-else>一口价是基于特定区域行程起终点，并按照预估里程区间进行计价调整的代驾服务。一口价超过预定里程区间的行驶里程会按照每公里加收一定费用，公里数不足1公里时按1公里收取。高速费、路桥费等其他费用按行驶过程中司机实际垫付费用收取。</div>
    </div>
    <div style="padding-top: .25rem;padding-bottom:1rem;">
      <van-row type="flex" justify="space-around">
        <van-col span="24">
          <div class="text-center font-hui">
            <a @click="getCityInfoFun()">计费规则<span class="iconfont icon-youjiantou"></span>
            </a>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  import util from '../../utils/util';
  import {
    getCityInfo,
  } from '@/apis/order/order';
  import mobileType from '../../utils/mobileType';

  export default {
    data() {
      return {
        data: {}
      };
    },
    created() {
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      // http://172.30.12.17:8088/home/fareEstimate?data=%7B%22personCountType%22%3A1%2C%22recieveFee%22%3A10%2C%22mileageFee%22%3A52.25%2C%22prePayMoney%22%3A65.25%2C%22carshareMoney%22%3A21.45%2C%22returnMoney%22%3A43.8%2C%22softVersion%22%3A%227.0.4%22%2C%22sysVersion%22%3A%22iOS%2010.0.1%22%2C%22platform%22%3A%223%22%2C%22channel%22%3A%2210600003%22%2C%22deviceId%22%3A%228386eae7-8551-4d18-be96-2979bfa28cae%22%2C%22cityCode%22%3A%22110105%22%2C%22thankFee%22%3A0%2C%22token%22%3A%22MTAxMTAwNjAxOjEwMDoyMDIwMDQyMTE3NTUyMTQ2Mw%253D%253D%22%7D
      let data = decodeURIComponent(this.$route.query.data);
      this.data = JSON.parse(data);
      this.getUserInfoFromApp();
      wsdata.track('DJ_EstimatedPricePageView', {
        is_fixed_price: this.data.chargeType == 4 ? 1 : 0
      })
    },
    filters: {
      calcPriceFun(val) {
        return util.calcPrice(val);
      },
      meters(val) {
        if (val) {
          const int = val / 1000;
          return util.getFloat(int, 1);
        } else {
          return 0.0;
        }
      },
      formatDuringFun(val) {
        return util.formatDuring(val);
      },
    },
    methods: {
      getUserInfoFromApp() {
        let params = {
          methodName: 'getDataFromNative',//定义与原生的方法名(固定)
          type: 1,//业务类型(固定)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.getDataFromVue.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.Android.getDataFromVue(JSON.stringify(params));
        } else {
        }
      },
      getDataFromNative(params) {
        if (mobileType.isIOS()) {
          this.params = params;
        } else if (mobileType.isAndroid()) {
          this.params = JSON.parse(params);
        }
      },
      //用于判断代码还是E代驾
      async getCityInfoFun() {
        let params;
        if (this.data.platform == 3) {
          params = {
            areaCode: this.data.areaCode,
            channel: this.data.channel,
            deviceId: this.data.deviceId,
            display: this.data.display,
            imei: this.data.imei,
            imsi: this.data.imsi,
            platform: this.data.platform,
            softVersion: this.data.softVersion,
            sysVersion: this.data.sysVersion,
            data: {
              cityCode: this.data.cityCode,
              orderType: this.data.orderType //  订单类型   实时单还是预约单等
            },
            token: this.data.token,
          };
        } else {
          params = {
            areaCode: this.params.areaCode,
            channel: this.params.channel,
            deviceId: this.params.deviceId,
            display: this.params.display,
            imei: this.params.imei,
            imsi: this.params.imsi,
            platform: this.params.platform,
            softVersion: this.params.softVersion,
            sysVersion: this.params.sysVersion,
            data: {
              cityCode: this.data.cityCode,
              orderType: this.data.orderType, // 订单类型   实时单还是预约单等
            },
            token: this.params.token,
          };
        }
        params.data = JSON.stringify(params.data);
        try {
          const data = await getCityInfo(params);
          if (data.code == 1 && data.data) {
            let data_ = JSON.parse(data.data);
            if (data_.useEDrivingEstimate == 1) {
              window.location.href = data_.eDrivingFeeUrl;
            } else {
              this.clickJF();
            }
          }else{
            this.$toast(data.msg);
          }
        } catch (error) {
        }
      },
      // 跳转计费规则
      clickJF() {
        let path = '/home/accountingRules';
        if(this.data.chargeType && this.data.chargeType == 4){
            path = '/home/accountingRulesFixed';
        }
        wsdata.track('DJ_PriceRuleClick', {
            is_fixed_price: this.data.chargeType == 4 ? 1 : 0
        })
        this.$router.push({
          path: path,
          query: {
            areaCode: this.data.areaCode,
            channel: this.data.channel,
            deviceId: this.data.deviceId,
            display: this.data.display,
            imei: this.data.imei,
            imsi: this.data.imsi,
            platform: this.data.platform,
            softVersion: this.data.softVersion,
            sysVersion: this.data.sysVersion,
            token: this.data.token,
            cityCode: this.data.cityCode,
            orderType: this.data.orderType,
            lat: this.data.lat,
            lon: this.data.lon,
            orderId: this.data.orderId,
            chargeType: this.data.chargeType
          }
        });
      },
    },
  };
</script>
<style scoped lang="less">
  .p48 {
    padding: 1rem 3rem 1.25rem 3rem;
  }

  .number {
    text-align: center;
    font-size: 0.9375rem;
    color: #333333;
    line-height: 1.3125rem;
    padding-bottom: 1rem;

    b {
      font-size: 1.5rem;
      font-weight: 400;
    }
  }


  hr {
    margin: 1rem 0;
    border-bottom: none;
    border-left: none;
    border-right: none;
    border-top: solid 0.0625rem #ECECEC;
  }

  .font-gray {
    font-size: 0.75rem;
    color: #999999;
    line-height: 1.0625rem;
  }

  .font-hui {
    font-size: 0.75rem;
    color: #666666;
    line-height: 1.0625rem;
  }

  .icon-youjiantou:before {
    position: relative;
    top: 0.125rem;
    background: #F4F5F6;
  }
</style>

